const KNOWN_THEME_KEYS = new Set([
    "city_services",
    "city_stores",
    "city_homes",
    "city_misc",
    "suburb_homes",
    "suburb_misc",
    "suburb_services",
    "suburb_stores",
]);
/** Map manifest ids (city_services_40) to theme family keys. */
export function parseBuildingThemeKey(buildingId) {
    const trimmed = buildingId.trim();
    if (!trimmed)
        return null;
    const parts = trimmed.split("_");
    if (parts.length < 3)
        return null;
    const key = `${parts[0]}_${parts[1]}`;
    if (!KNOWN_THEME_KEYS.has(key))
        return null;
    return key;
}
const DOWNTOWN_FALLBACK_PALETTE = {
    floorA: 0x2a2620,
    floorB: 0x343028,
    wall: 0x121018,
    wallHi: 0x1e1c28,
    wallBaseboard: false,
};
const SUBURB_FALLBACK_PALETTE = {
    floorA: 0x262a22,
    floorB: 0x2e342c,
    wall: 0x101410,
    wallHi: 0x1a1e1a,
    wallBaseboard: false,
};
const THEMES = {
    city_services: {
        key: "city_services",
        palette: {
            floorA: 0x2a3340,
            floorB: 0x354555,
            wall: 0x121820,
            wallHi: 0x1c2838,
            wallBaseboard: false,
        },
        pattern: "tileGrid",
        layout: {
            horizontalDividerChance: 0.3,
            verticalDividerChance: 0.5,
            allowNorthSouthExit: false,
        },
    },
    city_stores: {
        key: "city_stores",
        palette: {
            floorA: 0x3a3020,
            floorB: 0x4a4030,
            wall: 0x1a1814,
            wallHi: 0x282420,
            wallBaseboard: true,
        },
        pattern: "checker",
        layout: {
            horizontalDividerChance: 0.85,
            verticalDividerChance: 0.85,
            allowNorthSouthExit: false,
        },
    },
    suburb_homes: {
        key: "suburb_homes",
        palette: {
            floorA: 0x4a3828,
            floorB: 0x5c4838,
            wall: 0x2a2018,
            wallHi: 0x3a2e24,
            wallBaseboard: true,
        },
        pattern: "plank",
        layout: {
            horizontalDividerChance: 0.9,
            verticalDividerChance: 0.75,
            allowNorthSouthExit: true,
        },
    },
    suburb_misc: {
        key: "suburb_misc",
        palette: {
            floorA: 0x3a3a38,
            floorB: 0x484644,
            wall: 0x1a1a18,
            wallHi: 0x2e2c28,
            wallBaseboard: false,
        },
        pattern: "slab",
        layout: {
            horizontalDividerChance: 0.1,
            verticalDividerChance: 0.1,
            allowNorthSouthExit: false,
        },
    },
    suburb_services: {
        key: "suburb_services",
        palette: {
            floorA: 0x243028,
            floorB: 0x2e3c34,
            wall: 0x101810,
            wallHi: 0x182820,
            wallBaseboard: false,
        },
        pattern: "tileGrid",
        layout: {
            horizontalDividerChance: 0.3,
            verticalDividerChance: 0.5,
            allowNorthSouthExit: false,
        },
    },
    suburb_stores: {
        key: "suburb_stores",
        palette: {
            floorA: 0x2a3848,
            floorB: 0x344858,
            wall: 0x141820,
            wallHi: 0x202830,
            wallBaseboard: true,
        },
        pattern: "tileGrid",
        layout: {
            horizontalDividerChance: 0.85,
            verticalDividerChance: 0.85,
            allowNorthSouthExit: false,
        },
    },
    city_homes: {
        key: "city_homes",
        palette: {
            floorA: 0x423028,
            floorB: 0x524038,
            wall: 0x241c18,
            wallHi: 0x342a24,
            wallBaseboard: true,
        },
        pattern: "plank",
        layout: {
            horizontalDividerChance: 0.9,
            verticalDividerChance: 0.75,
            allowNorthSouthExit: true,
        },
    },
    city_misc: {
        key: "city_misc",
        palette: {
            floorA: 0x2a2e34,
            floorB: 0x343840,
            wall: 0x121418,
            wallHi: 0x1c2028,
            wallBaseboard: false,
        },
        pattern: "checker",
        layout: {
            horizontalDividerChance: 0.75,
            verticalDividerChance: 0.6,
            allowNorthSouthExit: false,
        },
    },
};
const DEFAULT_LAYOUT = {
    horizontalDividerChance: 0.75,
    verticalDividerChance: 0.6,
    allowNorthSouthExit: false,
};
export function resolveInteriorTheme(buildingId, downtown) {
    const key = parseBuildingThemeKey(buildingId);
    if (key && THEMES[key])
        return THEMES[key];
    return {
        key: "fallback",
        palette: downtown ? DOWNTOWN_FALLBACK_PALETTE : SUBURB_FALLBACK_PALETTE,
        pattern: "checker",
        layout: DEFAULT_LAYOUT,
    };
}
export function interiorThemeCacheKey(buildingId, downtown) {
    const theme = resolveInteriorTheme(buildingId, downtown);
    return theme.key === "fallback"
        ? `fallback_${downtown ? "downtown" : "suburb"}`
        : theme.key;
}
